import { render, staticRenderFns } from "./Bj.vue?vue&type=template&id=44784de6&scoped=true&"
import script from "./Bj.vue?vue&type=script&lang=js&"
export * from "./Bj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44784de6",
  null
  
)

export default component.exports